import { createFileRoute, Link } from "@tanstack/react-router";
import { useSEO } from "../../hooks/useSEO";
import { BlogPostView } from "../../blog/BlogPostView";
import { getPostBySlug } from "../../blog/posts";

export const Route = createFileRoute("/blog/$slug")({
  component: BlogPostPage,
});

function BlogPostPage() {
  const { slug } = Route.useParams();
  const post = getPostBySlug(slug);

  if (!post) return <BlogPostNotFound />;
  return (
    <div className="min-h-screen bg-white">
      <BlogPostView post={post} />
    </div>
  );
}

function BlogPostNotFound() {
  // Article not found — noindex so a bad URL isn't indexed, and offer the way back.
  useSEO({
    title: "Article Not Found — ProvenLeap",
    description: "The article you're looking for doesn't exist or has moved.",
    path: "/blog",
    robots: "noindex, nofollow",
  });
  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-foreground">Article not found</h1>
        <p className="mt-2 text-muted-foreground">This article doesn't exist or has moved.</p>
        <Link to="/blog" className="mt-4 inline-block text-brand hover:underline">
          ← Back to the blog
        </Link>
      </div>
    </div>
  );
}
